import {
  $activateTemplate,
  $addTemplateToApi,
  $cleanFileData,
  $copyDocument,
  $createDocument,
  $createDocumentByExistTemplate,
  $createDocumentFromFormRequest,
  $deleteDocument,
  $deleteDocuments,
  $disableForm,
  $enableForm,
  $getAllDocuments,
  $getAllTemplates,
  $getDocument,
  $getDocumentActivities,
  $getDocumentActivitiesDownloadUrl,
  $getDocumentByHash,
  $getDocumentDownloadUrl,
  $getEmbedDocument,
  $getFormRequest,
  $getFormRequests,
  $getReportByEmail,
  $getSeparateDocumentDownloadUrl,
  $mergeTemplate,
  $removeTemplateFromApi,
  $replicateTemplate,
  $revertDocument,
  $sendDocumentBulk,
  $sendReminder,
  $signSeparateDocument,
  $signSeparateDocumentActivities,
  $toggleEmailNotification,
  $updateDocument,
  $updateDocumentByExistTemplate,
  $updateEmbedDocument,
  $uploadDocument,
  activateTemplate,
  addTemplateToApi,
  cleanFileData,
  copyDocument,
  createDocument,
  createDocumentByExistTemplate,
  createDocumentFromFormRequest,
  deleteDocument,
  deleteDocuments,
  disableForm,
  enableForm,
  getAllDocuments,
  getAllTemplates,
  getDocument,
  getDocumentActivities,
  getDocumentActivitiesDownloadUrl,
  getDocumentByHash,
  getDocumentDownloadUrl,
  getEmbedDocument,
  getFormRequest,
  getFormRequests,
  getReportByEmail,
  getSeparateDocumentDownloadUrl,
  initEmbedDocumentToken,
  mergeTemplate,
  removeEmbedDocumenToken,
  removeTemplateFromApi,
  replicateTemplate,
  revertDocument,
  sendDocumentBulk,
  sendReminder,
  signSeparateDocument,
  signSeparateDocumentActivities,
  toggleEmailNotification,
  updateDocument,
  updateDocumentByExistTemplate,
  updateEmbedDocument,
  uploadDocument,
  watchDocumentConvertionProgress,
} from './actionCreators';
import reducer from './reducer';
import sagas from './sagas';

export default {
  sagas,
  reducer,
  actions: {
    createDocument,
    getDocument,
    sendReminder,
    getDocuments: getFormRequests,
    uploadDocument,
    updateDocument,
    getAllDocuments,
    mergeTemplate,
    replicateTemplate,
    revertDocument,
    deleteDocuments,
    copyDocument,
    cleanFileData,
    getDocumentDownloadUrl,
    getDocumentActivitiesDownloadUrl,
    activateTemplate,
    sendDocumentBulk,
    watchDocumentConvertionProgress,
    getDocumentActivities,
    createDocumentFromFormRequest,
    createDocumentByExistTemplate,
    updateDocumentByExistTemplate,
    removeTemplateFromApi,
    addTemplateToApi,
    getFormRequest,
    disableForm,
    enableForm,
    toggleEmailNotification,
    getAllTemplates,
    signSeparateDocument,
    getSeparateDocumentDownloadUrl,
    signSeparateDocumentActivities,
    deleteDocument,
    getDocumentByHash,
    getEmbedDocument,
    updateEmbedDocument,
    initEmbedDocumentToken,
    removeEmbedDocumenToken,
    getReportByEmail,
  },
};

export const $actions = {
  createDocument: $createDocument,
  getDocument: $getDocument,
  getDocumentByHash: $getDocumentByHash,
  getFormRequests: $getFormRequests,
  revertDocument: $revertDocument,
  mergeTemplate: $mergeTemplate,
  replicateTemplate: $replicateTemplate,
  sendReminder: $sendReminder,
  uploadDocument: $uploadDocument,
  updateDocument: $updateDocument,
  toggleEmailNotification: $toggleEmailNotification,
  sendDocumentBulk: $sendDocumentBulk,
  getAllDocuments: $getAllDocuments,
  copyDocument: $copyDocument,
  deleteDocuments: $deleteDocuments,
  cleanFileData: $cleanFileData,
  getDocumentDownloadUrl: $getDocumentDownloadUrl,
  getDocumentActivitiesDownloadUrl: $getDocumentActivitiesDownloadUrl,
  activateTemplate: $activateTemplate,
  getDocumentActivities: $getDocumentActivities,
  createDocumentFromFormRequest: $createDocumentFromFormRequest,
  createDocumentByExistTemplate: $createDocumentByExistTemplate,
  updateDocumentByExistTemplate: $updateDocumentByExistTemplate,
  addTemplateToApi: $addTemplateToApi,
  removeTemplateFromApi: $removeTemplateFromApi,
  getFormRequest: $getFormRequest,
  disableForm: $disableForm,
  enableForm: $enableForm,
  getAllTemplates: $getAllTemplates,
  signSeparateDocument: $signSeparateDocument,
  getSeparateDocumentDownloadUrl: $getSeparateDocumentDownloadUrl,
  signSeparateDocumentActivities: $signSeparateDocumentActivities,
  deleteDocument: $deleteDocument,
  getEmbedDocument: $getEmbedDocument,
  updateEmbedDocument: $updateEmbedDocument,
  getReportByEmail: $getReportByEmail,
};
